/*
 * Слежение за бездействием: после idleMs без действий пользователя вызывается
 * onIdle (приложение закрывает сессию). Любое действие — клик, клавиша,
 * прокрутка, касание, возврат на вкладку — перезапускает отсчёт, причём в
 * любой вкладке приложения: сессия у них общая.
 */

/**
 * Своё событие активности: разговор в звонке — тоже присутствие, но мышь и
 * клавиатура при нём стоят (баг Ильи 17.09.2026: посреди звонка обоих
 * выбрасывало из системы, и разговор обрывался). Приложение подаёт его само,
 * пока идёт звонок.
 */
export const ACTIVITY_EVENT = 'app-activity';

/** Сказать слежению, что человек здесь, хотя мышь и клавиатура молчат. */
export function markActivity(): void {
  window.dispatchEvent(new Event(ACTIVITY_EVENT));
}

const ACTIVITY = ['pointerdown', 'keydown', 'wheel', 'touchstart', ACTIVITY_EVENT] as const;

/**
 * Последнее действие в любой вкладке приложения (баг Ильи 02.10.2026). Сессия
 * у вкладок одна: выход из тихой вкладки выбивает и ту, где человек работает.
 * Звонок звенит во всех вкладках, отвечают в одной — и через 15 минут
 * соседняя выходила из системы, обрывая разговор.
 */
const SHARED_KEY = 'code-activity';

/** Памяти нет (частное окно, запрет на хранилище) — каждая вкладка сама по себе. */
function sharedLast(): number {
  try {
    return Number(localStorage.getItem(SHARED_KEY) ?? 0);
  } catch {
    return 0;
  }
}

function shareActivity(at: number): void {
  try {
    localStorage.setItem(SHARED_KEY, String(at));
  } catch {
    // без памяти браузера соседние вкладки об этом действии не узнают
  }
}

export function watchIdle(idleMs: number, onIdle: () => void): () => void {
  let timer: ReturnType<typeof setTimeout>;

  // Срок вышел — сперва спросить соседние вкладки: если там действовали
  // недавно, ждём остаток от их действия, а не выходим.
  const check = () => {
    const left = sharedLast() + idleMs - Date.now();
    if (left > 0) timer = setTimeout(check, left);
    else onIdle();
  };
  const arm = () => {
    clearTimeout(timer);
    shareActivity(Date.now());
    timer = setTimeout(check, idleMs);
  };
  const onVisible = () => {
    if (document.visibilityState === 'visible') arm();
  };

  for (const e of ACTIVITY) window.addEventListener(e, arm, { passive: true });
  document.addEventListener('visibilitychange', onVisible);
  arm();

  return () => {
    clearTimeout(timer);
    for (const e of ACTIVITY) window.removeEventListener(e, arm);
    document.removeEventListener('visibilitychange', onVisible);
  };
}
